import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n-composable'
import store from '@/store/store'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import { ListNames } from '@/store/modules/configuration/configurationTypes'
import CustomDialogActionButtonsComponent from '@/components/Dialog/CustomDialog/CustomDialogActionButtonsComponent.vue'
import SimpleGridTableComponent from '@/components/grids/SimpleGridTable/SimpleGridTableComponent.vue'
import SpinnerLayerComponent from '@/components/Spinner/SpinnerLayerComponent.vue'
import StaticAlertComponent from '@/components/Alert/StaticAlertComponent.vue'
import { AlertsTypes } from '@/store/modules/alerts/alertsTypes'


export default /*#__PURE__*/_defineComponent({
  __name: 'SageExportConflictsDialogComponent',
  props: {
    componentProps: { type: Object, required: true }
  },
  setup(__props: any) {

const props = __props as {
  componentProps: { conflicts: any[] }
};

const PAGE_SIZE = 5

const { t } = useI18n()

const sageConflictsGridColumns = ref<string>('')



const conflicts = computed(() => {
  const base = process.env.VUE_APP_FRONT_URL?.replace(/\/$/, '') ?? ''
  return (props.componentProps?.conflicts ?? []).map((conflict: any) => ({
    ...conflict,
    link: conflict.link ? `${base}/${conflict.link}` : conflict.link
  }))
})

const texts = {
  title: t('components.expedient_economic_data.sage_export_conflicts_title').toString(),
  subtitle: t('components.expedient_economic_data.sage_export_conflicts_subtitle').toString(),
  message: t('components.expedient_economic_data.sage_export_conflicts_message').toString(),
  gridTitle: t('components.expedient_economic_data.sage_export_conflicts_grid_title').toString(),
  primaryButtonText: t('action_buttons.cancel_export').toString()
}

const errorAlert = { type: AlertsTypes.ERROR, message: texts.title }

const closeDialog = () => {
  store.dispatch(`${ModuleNamespaces.DIALOG}/closeCustomDialog`)
}

onMounted(async () => {
  const alias = ListNames.BANKDRAFT_ERRORS_SAGE
  await store.dispatch(`${ModuleNamespaces.CONFIGURATION}/fetchCurrentListConfigurationContext`, {
    alias,
    context: alias
  })
  const parsed = store.getters[`${ModuleNamespaces.CONFIGURATION}/getCurrentListConfigurationContext`](alias) ?? {
    columns: []
  }
  sageConflictsGridColumns.value = JSON.stringify(parsed.columns?.[0] ?? [])
})

return { __sfc: true,PAGE_SIZE, t, sageConflictsGridColumns, props, conflicts, texts, errorAlert, closeDialog, CustomDialogActionButtonsComponent, SimpleGridTableComponent, SpinnerLayerComponent, StaticAlertComponent }
}

})